import { GlobalStyles } from '@mui/material';
import { createElement } from 'react';
import type { SxProps, Theme } from '@mui/material';

/**
 * Global CSS keyframes for real-time data update animations.
 * Mounted once in Layout.tsx via <RealtimeAnimationStyles />.
 */
export const RealtimeAnimationStyles = () =>
    createElement(GlobalStyles, {
        styles: {
            '@keyframes rtHighlightFlash': {
                '0%': { backgroundColor: 'rgba(76, 175, 80, 0.25)' },
                '100%': { backgroundColor: 'transparent' },
            },
            '@keyframes rtPulse': {
                '0%': { boxShadow: '0 0 0 0 rgba(76, 175, 80, 0.5)' },
                '70%': { boxShadow: '0 0 0 6px rgba(76, 175, 80, 0)' },
                '100%': { boxShadow: '0 0 0 0 rgba(76, 175, 80, 0)' },
            },
            '@keyframes rtValueFlashUp': {
                '0%': { backgroundColor: 'rgba(76, 175, 80, 0.35)' },
                '100%': { backgroundColor: 'transparent' },
            },
            '@keyframes rtValueFlashDown': {
                '0%': { backgroundColor: 'rgba(244, 67, 54, 0.35)' },
                '100%': { backgroundColor: 'transparent' },
            },
            '@keyframes rtBreathe': {
                '0%': { opacity: 1 },
                '50%': { opacity: 0.3 },
                '100%': { opacity: 1 },
            },
            '@keyframes rtHalo': {
                '0%': { opacity: 0.45, transform: 'scale(1)' },
                '100%': { opacity: 0, transform: 'scale(3)' },
            },
            '@media (prefers-reduced-motion: reduce)': {
                '.rt-halo': { animation: 'none !important' },
            },
        },
    });

/** Apply to a ListItemButton row to flash green on new data */
export const ROW_FLASH_SX: SxProps<Theme> = {
    animation: 'rtHighlightFlash 1.2s ease-out forwards',
};

/** Apply to a value element to flash green on increase */
export const VALUE_FLASH_UP_SX: SxProps<Theme> = {
    animation: 'rtValueFlashUp 1.2s ease-out forwards',
};

/** Apply to a value element to flash red on decrease */
export const VALUE_FLASH_DOWN_SX: SxProps<Theme> = {
    animation: 'rtValueFlashDown 1.2s ease-out forwards',
};

/** Apply to the live dot to breathe continuously */
export const DOT_BREATHE_SX: SxProps<Theme> = {
    animation: 'rtBreathe 2s ease-in-out infinite',
};
